import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	SpaceOverviewIdQuery,
	type SpaceOverviewIdQuery$data,
	type SpaceOverviewIdQuery$variables,
} from '@confluence/content-types-utils/entry-points/SpaceOverviewIdQuery.graphql.ts';

export function preloadSpaceOverviewId(spaceKey: string): Promise<{
	result: {
		data: SpaceOverviewIdQuery$data | null;
	};
	hasErrors: boolean;
}> {
	return query<SpaceOverviewIdQuery$data, SpaceOverviewIdQuery$variables>({
		query: SpaceOverviewIdQuery,
		variables: {
			spaceKey,
		},
	}).then((result) => ({ result, hasErrors: result.hasErrors }));
}
